import { asciiTextValidation } from 'framework/form';

export default {
  name: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  identifier: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  parentIdentifier: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  existedTeamsWebUrl: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateTeamsGroup: {
          in: [null, undefined, false],
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  existedGitlabWebUrl: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateGitlabGroup: {
          in: [null, undefined, false],
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  existedSharepointWebUrl: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateSharepoint: {
          in: [null, undefined, false],
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  teamsProjectCodeName: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateTeamsGroup: {
          eq: true,
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  gitlabGroupProjectCodeName: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateGitlabGroup: {
          eq: true,
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  gitlabGroupAccountAlias: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateGitlabGroup: {
          eq: true,
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
  sharepointProjectCodeName: {
    type: 'string',
    required: {
      value: true,
      when: {
        $isNeedToCreateSharepoint: {
          eq: true,
        },
      },
    },
    maxSize: 255,
    ...asciiTextValidation,
  },
};
